import{isNullOrUndefined as t,isMobxArray as e}from"./helpers.js";var r=function(r){return!!t(r)||("string"==typeof r||e(r)?0===r.length:0===Object.keys(r).length)},n=function(t){return!r(t)};export{r as isEmpty,n as isNotEmpty};
